import { render } from "./AccidentCheck.vue?vue&type=template&id=b23d01c8&scoped=true&ts=true"
import script from "./AccidentCheck.vue?vue&type=script&lang=ts"
export * from "./AccidentCheck.vue?vue&type=script&lang=ts"

import "./AccidentCheck.vue?vue&type=style&index=0&id=b23d01c8&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b23d01c8"]])

export default __exports__